import { render, staticRenderFns } from "./SelectPayment.vue?vue&type=template&id=52fc0df6&scoped=true"
import script from "./SelectPayment.vue?vue&type=script&lang=js"
export * from "./SelectPayment.vue?vue&type=script&lang=js"
import style0 from "./SelectPayment.vue?vue&type=style&index=0&id=52fc0df6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fc0df6",
  null
  
)

export default component.exports